import Vue from 'vue'
import 'tachyons'
import "font-awesome/css/font-awesome.css"
import "./main.css"
import App from './App.vue'
import Chart from 'vue2-frappe'
import Statistics from './components/Statistics.vue'
import TagStatistics from './components/TagStatistics.vue'
import {fixTask} from "./util/tests.js"
import task from "./util/empty.js"
import Task from "./model/Task.js"
Vue.use(Chart)
import VueRouter from 'vue-router'
Vue.use(VueRouter)
import VueTour from 'vue-tour'
import 'vue-tour/dist/vue-tour.css'
Vue.use(VueTour)
Vue.config.productionTip = false
const requireComponent = require.context(
    './components', // The relative path of the components folder
    false, // Whether or not to look in subfolders
    /\w+\.(vue|js)$/ // The regular expression used to match base component filenames
)
requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName) // Get component config
    const componentName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
    Vue.component(componentName, componentConfig.default || componentConfig) // Register component globally
})
Vue.prototype.log = console.log
import Root from "./components/Root.vue"
function statsDynamicPropsFn (route) {
    return {
        tag: "",
        id: (parseInt(route.params.id)),
    }
}
function statsTagDynamicPropsFn (route) {
    console.log("from statsTagDynamicPropsFn tag is: " + route.params.tagName);
    return {
        tag: route.params.tagName,
        id: (parseInt(route.params.id)),
    }
}
const StatsTitle = {
template: `
    <div class="nested-parent">
    <router-view class="view one"></router-view>
    <router-view class="view two" name="tagStats"></router-view>
    </div>
`
}
const routes = [
    { 
        path: '/', 
        component: Root 
    },
    { 
        path: '/stats/:id', 
        component: StatsTitle, 
        children: [
            { 
                path: '', 
                components: {
                    default: Statistics,
                    tagStats: TagStatistics
                },
                props: {
                    default: statsDynamicPropsFn,
                    tagStats: route => ({ id: (parseInt(route.params.id)) })
                }
            },
            {
                path: 'tag/:tagName',
                name: 'tag',
                component: Statistics,
                props: statsTagDynamicPropsFn
            }
        ]
    }
]
const router = new VueRouter({
  routes // short for `routes: routes`
})
new Vue({
    router,
    render: h => h(App),
    data: {
        tag: "", //global variables are bad I know
        tasks: null,
    },
    created(){
        if(localStorage.tasks){
            var tasks = Object.assign(new Task(), JSON.parse(localStorage.tasks))
            fixTask(tasks)
            this.tasks = tasks
        } else {
            this.tasks = task
        }
    },
    watch: {
        tasks: {
            handler: (newTasks) => {
                localStorage.tasks = JSON.stringify(newTasks)
            },
            deep: true
        }
    }
}).$mount('#app')
